import { createMessage, createMessages, SB } from '@play-co/replicant';
import { socialSchema } from './social.schema';
import { Social } from '.';

export const socialMessages = createMessages(SB.object(socialSchema))({
  setOnline: createMessage(SB.boolean(), (state, isOnline) => {
    state.isOnline = isOnline;
  }),

  /** Send a message to a user that someone joined the game through an invite */
  invitedUserJoined: createMessage(
    SB.object({
      invitedUserId: SB.string(),
      timeSent: SB.number(),
    }),
    (state, args) => {
      // Only add players that are not already in the list
      if (!state.social.invites[args.invitedUserId]) {
        state.social.invites[args.invitedUserId] = {
          timeSent: args.timeSent,
          referralRewardClaimed: false,
        };
      }
    },
  ),
});
